import React, { useEffect } from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import DatePicker from "~/shared/ui/Fields/DatePicker";
import { useSetLocationData } from "~/hooks/locationData";
import { addGMTOffsetToDate } from "~/shared/lib/addGMTOffsetToDate";

import s from "./HistoricalData.less";

type Props = {
  control: Control;
  refetch: any;
  watch: any;
  dealerId: string;
};

const HistoricalData = ({ control, refetch, watch, dealerId }: Props) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();

  const chosenDate = watch("actualOn");

  useEffect(() => {
    if (chosenDate) {
      refetch({
        PositionGroupId: dealerId,
        ActualOn: addGMTOffsetToDate(chosenDate),
      });
      setData("event", addGMTOffsetToDate(chosenDate));
    } else {
      refetch({ PositionGroupId: dealerId, ActualOn: null });
      setData("event", null);
    }
  }, [chosenDate, dealerId]);

  return (
    <div className={s.wrapper}>
      <span className={s.text}>{t("patp.actual_date_on")}</span>
      <DatePicker
        name={"actualOn"}
        control={control}
        gray
        maxDate={new Date()}
        customClassName={s.date_picker}
        dateFormat={"dd.MM.yyyy"}
      />
    </div>
  );
};

export default HistoricalData;
